// Local translations
export const T = {
  en_GB: {
    editCustomField: "Edit Custom Field",
    addNewCustomField: "Add New Custom Field",
    updateFieldDescription: "Update the custom field information below.",
    createFieldDescription: "Create a new custom field to add to your clients.",
    fieldName: "Field Name",
    fieldNamePlaceholder: "e.g., Company Size",
    fieldType: "Field Type",
    selectFieldType: "Select field type",
    fieldTypeCannotChange: "Field type cannot be changed after creation",
    typeText: "Text",
    typeTextarea: "Textarea",
    typeNumber: "Number",
    typeDate: "Date",
    typeDateTime: "Date and time",
    typeDropdown: "Dropdown",
    typeRadio: "Radio buttons",
    typeMultiselect: "Multi-select (checkboxes)",
    typeBoolean: "Checkbox (yes/no)",
    singleLineText: "Single line text input",
    multiLineText: "Multi-line text input",
    numericInput: "Numeric input only",
    datePicker: "Date picker",
    dateTimePicker: "Date and time picker, shown in each user's own timezone",
    predefinedOptions: "Predefined list of options",
    radioOptions: "Pick one option, shown as radio buttons",
    multiselectOptions: "Pick one or more options, shown as checkboxes",
    booleanInput: "A single yes/no checkbox",
    appliesToLabel: "Applies to",
    selectClientType: "Select client type",
    allClientTypes: "All client types",
    personOnly: "Person only",
    companyOnly: "Company only",
    groupOnly: "Group only",
    whichClientType: "Which type of client this field should be shown for",
    tabLabel: "Tab",
    selectTab: "Select tab",
    defaultTab: "Default",
    whichTab: "Which tab this field should appear on in the client dialog",
    dropdownOptions: "Options",
    addOption: "Add option",
    optionsRequired: "Option fields must have at least one option",
    optionLabelRequired: "Every option needs a label",
    optionLabel: "Option",
    moveOptionUp: "Move option up",
    moveOptionDown: "Move option down",
    removeOption: "Remove option",
    optionEditHint: "Editing an option's text updates it everywhere it is already selected",
    visibilitySettings: "Visibility Settings",
    visibleInList: "Visible in List",
    visibleInProfile: "Visible in Profile",
    showInClientTable: "Show this field in the client table",
    showOnClientPage: "Show this field on the client page",
    visibleInListOnlyAllTypes:
      '"Visible in List" is only available for fields that apply to all client types',
    alwaysVisibleWhenEditing: "Note: All fields are always visible when editing a client",
    cancel: "Cancel",
    addCustomField: "Add Custom Field",
    save: "Save",
    failedToSave: "Failed to save custom field",
    somethingWentWrong: "Something went wrong",
  },
  nb_NO: {
    editCustomField: "Rediger egendefinert felt",
    addNewCustomField: "Legg til nytt egendefinert felt",
    updateFieldDescription: "Oppdater informasjonen for det egendefinerte feltet nedenfor.",
    createFieldDescription: "Opprett et nytt egendefinert felt for kundene dine.",
    fieldName: "Feltnavn",
    fieldNamePlaceholder: "f.eks. Bedriftsstørrelse",
    fieldType: "Felttype",
    selectFieldType: "Velg felttype",
    fieldTypeCannotChange: "Felttype kan ikke endres etter opprettelse",
    typeText: "Tekst",
    typeTextarea: "Tekstområde",
    typeNumber: "Tall",
    typeDate: "Dato",
    typeDateTime: "Dato og klokkeslett",
    typeDropdown: "Nedtrekksliste",
    typeRadio: "Radioknapper",
    typeMultiselect: "Flervalg (avkrysningsbokser)",
    typeBoolean: "Avkrysningsboks (ja/nei)",
    singleLineText: "Enkeltlinje tekstfelt",
    multiLineText: "Flerlinje tekstfelt",
    numericInput: "Kun numerisk inndata",
    datePicker: "Datovelger",
    dateTimePicker: "Dato- og tidsvelger, vist i hver brukers egen tidssone",
    predefinedOptions: "Forhåndsdefinert liste med valg",
    radioOptions: "Velg ett alternativ, vist som radioknapper",
    multiselectOptions: "Velg ett eller flere alternativer, vist som avkrysningsbokser",
    booleanInput: "En enkelt ja/nei-avkrysningsboks",
    appliesToLabel: "Gjelder for",
    selectClientType: "Velg kundetype",
    allClientTypes: "Alle kundetyper",
    personOnly: "Kun person",
    companyOnly: "Kun selskap",
    groupOnly: "Kun gruppe",
    whichClientType: "Hvilken type kunde dette feltet skal vises for",
    tabLabel: "Fane",
    selectTab: "Velg fane",
    defaultTab: "Standard",
    whichTab: "Hvilken fane dette feltet skal vises på i kundedialogen",
    dropdownOptions: "Alternativer",
    addOption: "Legg til alternativ",
    optionsRequired: "Alternativfelt må ha minst ett alternativ",
    optionLabelRequired: "Alle alternativer må ha en tekst",
    optionLabel: "Alternativ",
    moveOptionUp: "Flytt alternativet opp",
    moveOptionDown: "Flytt alternativet ned",
    removeOption: "Fjern alternativ",
    optionEditHint:
      "Endrer du teksten på et alternativ, oppdateres den overalt der det allerede er valgt",
    visibilitySettings: "Synlighetsinnstillinger",
    visibleInList: "Synlig i liste",
    visibleInProfile: "Synlig i profil",
    showInClientTable: "Vis dette feltet i kundetabellen",
    showOnClientPage: "Vis dette feltet på kundesiden",
    visibleInListOnlyAllTypes:
      '"Synlig i liste" er kun tilgjengelig for felt som gjelder alle kundetyper',
    alwaysVisibleWhenEditing: "Merk: Alle felt er alltid synlige ved redigering av en kunde",
    cancel: "Avbryt",
    addCustomField: "Legg til egendefinert felt",
    save: "Lagre",
    failedToSave: "Kunne ikke lagre egendefinert felt",
    somethingWentWrong: "Noe gikk galt",
  },
} as const;
